import { render, staticRenderFns } from "./RateTicket.vue?vue&type=template&id=08522ed3&scoped=true"
import script from "./RateTicket.vue?vue&type=script&lang=js"
export * from "./RateTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08522ed3",
  null
  
)

export default component.exports